import { render } from "./ImportContrat.vue?vue&type=template&id=b3c2ca9a"
import script from "./ImportContrat.vue?vue&type=script&lang=ts"
export * from "./ImportContrat.vue?vue&type=script&lang=ts"
script.render = render

export default script